import { CASES } from "./constants";

export const updatePMXPricesAndDates = (payload) => {
  return { type: CASES.UPDATE_PMX_PRICES_AND_DATES, payload };
};

export const updatePMXPricesAndDatesSearchForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_PMX_PRICES_AND_DATES_SEARCH_FORM,
    payload: { key, data },
  };
};

export const clearPMXPricesAndDates = () => {
  return { type: CASES.CLEAR_PMX_PRICES_AND_DATES, payload: {} };
};
